import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ScrollReveal from "../components/ScrollReveal";

// Comprehensive list of countries with phone codes and ISO3 codes, ordered alphabetically by country name
const countries = [
  { name: "Afghanistan", code: "+93", iso3: "AFG" },
  { name: "Albania", code: "+355", iso3: "ALB" },
  { name: "Algeria", code: "+213", iso3: "DZA" },
  { name: "American Samoa", code: "+1684", iso3: "ASM" },
  { name: "Andorra", code: "+376", iso3: "AND" },
  { name: "Angola", code: "+244", iso3: "AGO" },
  { name: "Anguilla", code: "+1264", iso3: "AIA" },
  { name: "Antarctica", code: "+672", iso3: "ATA" },
  { name: "Antigua and Barbuda", code: "+1268", iso3: "ATG" },
  { name: "Argentina", code: "+54", iso3: "ARG" },
  { name: "Armenia", code: "+374", iso3: "ARM" },
  { name: "Aruba", code: "+297", iso3: "ABW" },
  { name: "Australia", code: "+61", iso3: "AUS" },
  { name: "Austria", code: "+43", iso3: "AUT" },
  { name: "Azerbaijan", code: "+994", iso3: "AZE" },
  { name: "Bahamas", code: "+1242", iso3: "BHS" },
  { name: "Bahrain", code: "+973", iso3: "BHR" },
  { name: "Bangladesh", code: "+880", iso3: "BGD" },
  { name: "Barbados", code: "+1246", iso3: "BRB" },
  { name: "Belarus", code: "+375", iso3: "BLR" },
  { name: "Belgium", code: "+32", iso3: "BEL" },
  { name: "Belize", code: "+501", iso3: "BLZ" },
  { name: "Benin", code: "+229", iso3: "BEN" },
  { name: "Bermuda", code: "+1441", iso3: "BMU" },
  { name: "Bhutan", code: "+975", iso3: "BTN" },
  { name: "Bolivia", code: "+591", iso3: "BOL" },
  { name: "Bosnia and Herzegovina", code: "+387", iso3: "BIH" },
  { name: "Botswana", code: "+267", iso3: "BWA" },
  { name: "Brazil", code: "+55", iso3: "BRA" },
  { name: "British Indian Ocean Territory", code: "+246", iso3: "IOT" },
  { name: "British Virgin Islands", code: "+1284", iso3: "VGB" },
  { name: "Brunei", code: "+673", iso3: "BRN" },
  { name: "Bulgaria", code: "+359", iso3: "BGR" },
  { name: "Burkina Faso", code: "+226", iso3: "BFA" },
  { name: "Burundi", code: "+257", iso3: "BDI" },
  { name: "Cambodia", code: "+855", iso3: "KHM" },
  { name: "Cameroon", code: "+237", iso3: "CMR" },
  { name: "Canada", code: "+1", iso3: "CAN" },
  { name: "Cape Verde", code: "+238", iso3: "CPV" },
  { name: "Cayman Islands", code: "+1345", iso3: "CYM" },
  { name: "Central African Republic", code: "+236", iso3: "CAF" },
  { name: "Chad", code: "+235", iso3: "TCD" },
  { name: "Chile", code: "+56", iso3: "CHL" },
  { name: "China", code: "+86", iso3: "CHN" },
  { name: "Christmas Island", code: "+61", iso3: "CXR" },
  { name: "Cocos Islands", code: "+61", iso3: "CCK" },
  { name: "Colombia", code: "+57", iso3: "COL" },
  { name: "Comoros", code: "+269", iso3: "COM" },
  { name: "Cook Islands", code: "+682", iso3: "COK" },
  { name: "Costa Rica", code: "+506", iso3: "CRI" },
  { name: "Croatia", code: "+385", iso3: "HRV" },
  { name: "Cuba", code: "+53", iso3: "CUB" },
  { name: "Curacao", code: "+599", iso3: "CUW" },
  { name: "Cyprus", code: "+357", iso3: "CYP" },
  { name: "Czech Republic", code: "+420", iso3: "CZE" },
  { name: "Democratic Republic of the Congo", code: "+243", iso3: "COD" },
  { name: "Denmark", code: "+45", iso3: "DNK" },
  { name: "Djibouti", code: "+253", iso3: "DJI" },
  { name: "Dominica", code: "+1767", iso3: "DMA" },
  { name: "Dominican Republic", code: "+1809", iso3: "DOM" },
  { name: "East Timor", code: "+670", iso3: "TLS" },
  { name: "Ecuador", code: "+593", iso3: "ECU" },
  { name: "Egypt", code: "+20", iso3: "EGY" },
  { name: "El Salvador", code: "+503", iso3: "SLV" },
  { name: "Equatorial Guinea", code: "+240", iso3: "GNQ" },
  { name: "Eritrea", code: "+291", iso3: "ERI" },
  { name: "Estonia", code: "+372", iso3: "EST" },
  { name: "Ethiopia", code: "+251", iso3: "ETH" },
  { name: "Falkland Islands", code: "+500", iso3: "FLK" },
  { name: "Faroe Islands", code: "+298", iso3: "FRO" },
  { name: "Fiji", code: "+679", iso3: "FJI" },
  { name: "Finland", code: "+358", iso3: "FIN" },
  { name: "France", code: "+33", iso3: "FRA" },
  { name: "French Polynesia", code: "+689", iso3: "PYF" },
  { name: "Gabon", code: "+241", iso3: "GAB" },
  { name: "Gambia", code: "+220", iso3: "GMB" },
  { name: "Georgia", code: "+995", iso3: "GEO" },
  { name: "Germany", code: "+49", iso3: "DEU" },
  { name: "Ghana", code: "+233", iso3: "GHA" },
  { name: "Gibraltar", code: "+350", iso3: "GIB" },
  { name: "Greece", code: "+30", iso3: "GRC" },
  { name: "Greenland", code: "+299", iso3: "GRL" },
  { name: "Grenada", code: "+1473", iso3: "GRD" },
  { name: "Guam", code: "+1671", iso3: "GUM" },
  { name: "Guatemala", code: "+502", iso3: "GTM" },
  { name: "Guernsey", code: "+44", iso3: "GGY" },
  { name: "Guinea", code: "+224", iso3: "GIN" },
  { name: "Guinea-Bissau", code: "+245", iso3: "GNB" },
  { name: "Guyana", code: "+592", iso3: "GUY" },
  { name: "Haiti", code: "+509", iso3: "HTI" },
  { name: "Honduras", code: "+504", iso3: "HND" },
  { name: "Hong Kong", code: "+852", iso3: "HKG" },
  { name: "Hungary", code: "+36", iso3: "HUN" },
  { name: "Iceland", code: "+354", iso3: "ISL" },
  { name: "India", code: "+91", iso3: "IND" },
  { name: "Indonesia", code: "+62", iso3: "IDN" },
  { name: "Iran", code: "+98", iso3: "IRN" },
  { name: "Iraq", code: "+964", iso3: "IRQ" },
  { name: "Ireland", code: "+353", iso3: "IRL" },
  { name: "Isle of Man", code: "+44", iso3: "IMN" },
  { name: "Israel", code: "+972", iso3: "ISR" },
  { name: "Italy", code: "+39", iso3: "ITA" },
  { name: "Ivory Coast", code: "+225", iso3: "CIV" },
  { name: "Jamaica", code: "+1876", iso3: "JAM" },
  { name: "Japan", code: "+81", iso3: "JPN" },
  { name: "Jersey", code: "+44", iso3: "JEY" },
  { name: "Jordan", code: "+962", iso3: "JOR" },
  { name: "Kazakhstan", code: "+7", iso3: "KAZ" },
  { name: "Kenya", code: "+254", iso3: "KEN" },
  { name: "Kiribati", code: "+686", iso3: "KIR" },
  { name: "Kosovo", code: "+383", iso3: "XKX" },
  { name: "Kuwait", code: "+965", iso3: "KWT" },
  { name: "Kyrgyzstan", code: "+996", iso3: "KGZ" },
  { name: "Laos", code: "+856", iso3: "LAO" },
  { name: "Latvia", code: "+371", iso3: "LVA" },
  { name: "Lebanon", code: "+961", iso3: "LBN" },
  { name: "Lesotho", code: "+266", iso3: "LSO" },
  { name: "Liberia", code: "+231", iso3: "LBR" },
  { name: "Libya", code: "+218", iso3: "LBY" },
  { name: "Liechtenstein", code: "+423", iso3: "LIE" },
  { name: "Lithuania", code: "+370", iso3: "LTU" },
  { name: "Luxembourg", code: "+352", iso3: "LUX" },
  { name: "Macau", code: "+853", iso3: "MAC" },
  { name: "Macedonia", code: "+389", iso3: "MKD" },
  { name: "Madagascar", code: "+261", iso3: "MDG" },
  { name: "Malawi", code: "+265", iso3: "MWI" },
  { name: "Malaysia", code: "+60", iso3: "MYS" },
  { name: "Maldives", code: "+960", iso3: "MDV" },
  { name: "Mali", code: "+223", iso3: "MLI" },
  { name: "Malta", code: "+356", iso3: "MLT" },
  { name: "Marshall Islands", code: "+692", iso3: "MHL" },
  { name: "Mauritania", code: "+222", iso3: "MRT" },
  { name: "Mauritius", code: "+230", iso3: "MUS" },
  { name: "Mayotte", code: "+262", iso3: "MYT" },
  { name: "Mexico", code: "+52", iso3: "MEX" },
  { name: "Micronesia", code: "+691", iso3: "FSM" },
  { name: "Moldova", code: "+373", iso3: "MDA" },
  { name: "Monaco", code: "+377", iso3: "MCO" },
  { name: "Mongolia", code: "+976", iso3: "MNG" },
  { name: "Montenegro", code: "+382", iso3: "MNE" },
  { name: "Montserrat", code: "+1664", iso3: "MSR" },
  { name: "Morocco", code: "+212", iso3: "MAR" },
  { name: "Mozambique", code: "+258", iso3: "MOZ" },
  { name: "Myanmar", code: "+95", iso3: "MMR" },
  { name: "Namibia", code: "+264", iso3: "NAM" },
  { name: "Nauru", code: "+674", iso3: "NRU" },
  { name: "Nepal", code: "+977", iso3: "NPL" },
  { name: "Netherlands", code: "+31", iso3: "NLD" },
  { name: "Netherlands Antilles", code: "+599", iso3: "ANT" },
  { name: "New Caledonia", code: "+687", iso3: "NCL" },
  { name: "New Zealand", code: "+64", iso3: "NZL" },
  { name: "Nicaragua", code: "+505", iso3: "NIC" },
  { name: "Niger", code: "+227", iso3: "NER" },
  { name: "Nigeria", code: "+234", iso3: "NGA" },
  { name: "Niue", code: "+683", iso3: "NIU" },
  { name: "North Korea", code: "+850", iso3: "PRK" },
  { name: "Northern Mariana Islands", code: "+1670", iso3: "MNP" },
  { name: "Norway", code: "+47", iso3: "NOR" },
  { name: "Oman", code: "+968", iso3: "OMN" },
  { name: "Pakistan", code: "+92", iso3: "PAK" },
  { name: "Palau", code: "+680", iso3: "PLW" },
  { name: "Palestine", code: "+970", iso3: "PSE" },
  { name: "Panama", code: "+507", iso3: "PAN" },
  { name: "Papua New Guinea", code: "+675", iso3: "PNG" },
  { name: "Paraguay", code: "+595", iso3: "PRY" },
  { name: "Peru", code: "+51", iso3: "PER" },
  { name: "Philippines", code: "+63", iso3: "PHL" },
  { name: "Pitcairn", code: "+64", iso3: "PCN" },
  { name: "Poland", code: "+48", iso3: "POL" },
  { name: "Portugal", code: "+351", iso3: "PRT" },
  { name: "Puerto Rico", code: "+1787", iso3: "PRI" },
  { name: "Qatar", code: "+974", iso3: "QAT" },
  { name: "Republic of the Congo", code: "+242", iso3: "COG" },
  { name: "Reunion", code: "+262", iso3: "REU" },
  { name: "Romania", code: "+40", iso3: "ROU" },
  { name: "Russia", code: "+7", iso3: "RUS" },
  { name: "Rwanda", code: "+250", iso3: "RWA" },
  { name: "Saint Barthelemy", code: "+590", iso3: "BLM" },
  { name: "Saint Helena", code: "+290", iso3: "SHN" },
  { name: "Saint Kitts and Nevis", code: "+1869", iso3: "KNA" },
  { name: "Saint Lucia", code: "+1758", iso3: "LCA" },
  { name: "Saint Martin", code: "+590", iso3: "MAF" },
  { name: "Saint Pierre and Miquelon", code: "+508", iso3: "SPM" },
  { name: "Saint Vincent and the Grenadines", code: "+1784", iso3: "VCT" },
  { name: "Samoa", code: "+685", iso3: "WSM" },
  { name: "San Marino", code: "+378", iso3: "SMR" },
  { name: "Sao Tome and Principe", code: "+239", iso3: "STP" },
  { name: "Saudi Arabia", code: "+966", iso3: "SAU" },
  { name: "Senegal", code: "+221", iso3: "SEN" },
  { name: "Serbia", code: "+381", iso3: "SRB" },
  { name: "Seychelles", code: "+248", iso3: "SYC" },
  { name: "Sierra Leone", code: "+232", iso3: "SLE" },
  { name: "Singapore", code: "+65", iso3: "SGP" },
  { name: "Sint Maarten", code: "+1721", iso3: "SXM" },
  { name: "Slovakia", code: "+421", iso3: "SVK" },
  { name: "Slovenia", code: "+386", iso3: "SVN" },
  { name: "Solomon Islands", code: "+677", iso3: "SLB" },
  { name: "Somalia", code: "+252", iso3: "SOM" },
  { name: "South Africa", code: "+27", iso3: "ZAF" },
  { name: "South Korea", code: "+82", iso3: "KOR" },
  { name: "South Sudan", code: "+211", iso3: "SSD" },
  { name: "Spain", code: "+34", iso3: "ESP" },
  { name: "Sri Lanka", code: "+94", iso3: "LKA" },
  { name: "Sudan", code: "+249", iso3: "SDN" },
  { name: "Suriname", code: "+597", iso3: "SUR" },
  { name: "Svalbard and Jan Mayen", code: "+47", iso3: "SJM" },
  { name: "Swaziland", code: "+268", iso3: "SWZ" },
  { name: "Sweden", code: "+46", iso3: "SWE" },
  { name: "Switzerland", code: "+41", iso3: "CHE" },
  { name: "Syria", code: "+963", iso3: "SYR" },
  { name: "Taiwan", code: "+886", iso3: "TWN" },
  { name: "Tajikistan", code: "+992", iso3: "TJK" },
  { name: "Tanzania", code: "+255", iso3: "TZA" },
  { name: "Thailand", code: "+66", iso3: "THA" },
  { name: "Togo", code: "+228", iso3: "TGO" },
  { name: "Tokelau", code: "+690", iso3: "TKL" },
  { name: "Tonga", code: "+676", iso3: "TON" },
  { name: "Trinidad and Tobago", code: "+1868", iso3: "TTO" },
  { name: "Tunisia", code: "+216", iso3: "TUN" },
  { name: "Turkey", code: "+90", iso3: "TUR" },
  { name: "Turkmenistan", code: "+993", iso3: "TKM" },
  { name: "Turks and Caicos Islands", code: "+1649", iso3: "TCA" },
  { name: "Tuvalu", code: "+688", iso3: "TUV" },
  { name: "U.S. Virgin Islands", code: "+1340", iso3: "VIR" },
  { name: "Uganda", code: "+256", iso3: "UGA" },
  { name: "Ukraine", code: "+380", iso3: "UKR" },
  { name: "United Arab Emirates", code: "+971", iso3: "ARE" },
  { name: "United Kingdom", code: "+44", iso3: "GBR" },
  { name: "United States", code: "+1", iso3: "USA" },
  { name: "Uruguay", code: "+598", iso3: "URY" },
  { name: "Uzbekistan", code: "+998", iso3: "UZB" },
  { name: "Vanuatu", code: "+678", iso3: "VUT" },
  { name: "Vatican", code: "+379", iso3: "VAT" },
  { name: "Venezuela", code: "+58", iso3: "VEN" },
  { name: "Vietnam", code: "+84", iso3: "VNM" },
  { name: "Wallis and Futuna", code: "+681", iso3: "WLF" },
  { name: "Western Sahara", code: "+212", iso3: "ESH" },
  { name: "Yemen", code: "+967", iso3: "YEM" },
  { name: "Zambia", code: "+260", iso3: "ZMB" },
  { name: "Zimbabwe", code: "+263", iso3: "ZWE" },
];

// Add a function to get the display value for the selected country
const getDisplayValue = (countryCode: string) => {
  const country = countries.find((c) => c.code === countryCode);
  return country ? country.code : countryCode;
};

// Product options
const products = [
  {
    id: "exposure-management",
    name: "Exposure Management",
    description: "Platform that discovers, correlates, and prioritises external and third-party risks.",
  },
  {
    id: "soc-agent",
    name: "SOC AI Agent",
    description: "Automates SOC operations with intelligent, self-learning AI agents.",
  },
  {
    id: "internet-intel",
    name: "Internet-wide Intelligence",
    description: "Delivers real-time insights from global internet-wide data.",
  },
];

const BookDemoPage: React.FC = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    company: "",
    email: "",
    countryCode: "+1",
    phone: "",
    message: "",
    interestedProducts: [] as string[],
  });

  const [errors, setErrors] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
  });

  const [submissionStatus, setSubmissionStatus] = useState({
    loading: false,
    message: "",
  });

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const dropdownListRef = useRef<HTMLDivElement>(null);

  // Handle clicks outside dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
        setHighlightedIndex(-1);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!isDropdownOpen) return;

      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          setHighlightedIndex((prev) => (prev < countries.length - 1 ? prev + 1 : 0));
          break;
        case "ArrowUp":
          event.preventDefault();
          setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : countries.length - 1));
          break;
        case "Enter":
          event.preventDefault();
          if (highlightedIndex >= 0) {
            handleCountrySelect(countries[highlightedIndex].code);
          }
          break;
        case "Escape":
          setIsDropdownOpen(false);
          setHighlightedIndex(-1);
          break;
        default:
          // Handle typing first character to jump to country
          if (event.key.length === 1) {
            const typedChar = event.key.toLowerCase();
            const matchingIndex = countries.findIndex((country) => country.name.toLowerCase().startsWith(typedChar));
            if (matchingIndex >= 0) {
              setHighlightedIndex(matchingIndex);
            }
          }
          break;
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("keydown", handleKeyDown);
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [isDropdownOpen, highlightedIndex]);

  // Auto-scroll to highlighted item
  useEffect(() => {
    if (highlightedIndex >= 0 && dropdownListRef.current) {
      const highlightedElement = dropdownListRef.current.children[highlightedIndex] as HTMLElement;
      if (highlightedElement) {
        highlightedElement.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }, [highlightedIndex]);

  const handleCountrySelect = (countryCode: string) => {
    setFormData({ ...formData, countryCode });
    setIsDropdownOpen(false);
    setHighlightedIndex(-1);
  };

  const getSelectedCountry = () => {
    return countries.find((country) => country.code === formData.countryCode);
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
      isValid = false;
    } else {
      newErrors.name = "";
    }

    if (!formData.company.trim()) {
      newErrors.company = "Company name is required";
      isValid = false;
    } else {
      newErrors.company = "";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
      isValid = false;
    } else {
      newErrors.email = "";
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleProductSelection = (productId: string) => {
    setFormData((prev) => {
      const isSelected = prev.interestedProducts.includes(productId);
      const updatedProducts = isSelected
        ? prev.interestedProducts.filter((id) => id !== productId)
        : [...prev.interestedProducts, productId];

      return { ...prev, interestedProducts: updatedProducts };
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validateForm()) {
      try {
        setSubmissionStatus({ loading: true, message: "Sending your request..." });

        // Create FormData object for web3forms
        const formDataObj = new FormData();

        // Add form fields to FormData
        formDataObj.append("name", formData.name);
        formDataObj.append("company", formData.company);
        formDataObj.append("email", formData.email);
        formDataObj.append("phone", `${formData.countryCode} ${formData.phone}`);
        formDataObj.append("message", formData.message);
        formDataObj.append(
          "interestedProducts",
          formData.interestedProducts
            .map((id) => products.find((p) => p.id === id)?.name)
            .filter(Boolean)
            .join(", ")
        );

        // Add access key for web3forms
        formDataObj.append("access_key", "3538f588-ad0a-41ee-8716-864a36b287df");

        // Submit form to web3forms
        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: formDataObj,
        });

        const data = await response.json();

        if (data.success) {
          setSubmissionStatus({ loading: false, message: "Form submitted successfully!" });
          // Redirect to thank-you page after successful submission
          setTimeout(() => {
            navigate("/thank-you");
          }, 1000);
        } else {
          console.error("Form submission error:", data);
          setSubmissionStatus({ loading: false, message: data.message || "Something went wrong. Please try again." });
        }
      } catch (error) {
        console.error("Form submission error:", error);
        setSubmissionStatus({ loading: false, message: "An unexpected error occurred. Please try again." });
      }
    }
  };

  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <ScrollReveal className="hero-content" direction="up" delay={200}>
            <h1 className="hero-title">Request Your Free Demo</h1>
            <p className="hero-description">
              Experience how spiderSilk transforms your risk detection and response. Fill out the form and we'll handle
              the rest.
            </p>
          </ScrollReveal>
        </div>
      </section>

      <main className="main">
        <div className="main__curved curved-ellipse"></div>
        <div className="main__curved-line curved-ellipse"></div>

        {/* Book-demo Section */}
        <section className="book-demo">
          <div className="book-demo-container container">
            <ScrollReveal direction="left" delay={300}>
              <form className="book-demo-form" onSubmit={handleSubmit}>
                {/* Submission Status Message */}
                {submissionStatus.message && (
                  <div className={`demo-form__status ${submissionStatus.loading ? "loading" : "success"}`}>
                    {submissionStatus.message}
                  </div>
                )}

                {/* Row 1 */}
                <div className="demo-form__row">
                  <label htmlFor="name" className="demo-form__label">
                    Name*
                  </label>
                  <div className="demo-form__input-wrapper">
                    <input
                      type="text"
                      id="demo-form-name-input"
                      name="name"
                      className={`demo-form__input ${errors.name ? "error" : formData.name ? "success" : ""}`}
                      placeholder="Alex Green"
                      value={formData.name}
                      onChange={handleInputChange}
                      disabled={submissionStatus.loading}
                    />
                    {formData.name && !errors.name && (
                      <span className="demo-form__icon">
                        <img src="/images/success-mark.svg" alt="success mark" />
                      </span>
                    )}
                  </div>
                  {errors.name && (
                    <span className="demo-form__error">
                      <img src="/images/vulnerability-filled-icon.svg" alt="vulnerability" />
                      <span>{errors.name}</span>
                    </span>
                  )}
                </div>

                {/* Row 2 */}
                <div className="demo-form__row">
                  <label htmlFor="company" className="demo-form__label">
                    Company name*
                  </label>
                  <div className="demo-form__input-wrapper">
                    <input
                      type="text"
                      id="demo-form-company-input"
                      name="company"
                      className={`demo-form__input ${errors.company ? "error" : formData.company ? "success" : ""}`}
                      placeholder="Acme Inc"
                      value={formData.company}
                      onChange={handleInputChange}
                      disabled={submissionStatus.loading}
                    />
                    {formData.company && !errors.company && (
                      <span className="demo-form__icon">
                        <img src="/images/success-mark.svg" alt="success mark" />
                      </span>
                    )}
                  </div>
                  {errors.company && (
                    <span className="demo-form__error">
                      <img src="/images/vulnerability-filled-icon.svg" alt="vulnerability" />
                      <span>{errors.company}</span>
                    </span>
                  )}
                </div>

                {/* Row 3 */}
                <div className="demo-form__row">
                  <label htmlFor="email" className="demo-form__label">
                    Business email*
                  </label>
                  <div className="demo-form__input-wrapper">
                    <input
                      type="email"
                      id="demo-form-email-input"
                      name="email"
                      className={`demo-form__input ${errors.email ? "error" : formData.email ? "success" : ""}`}
                      placeholder="alex@acme.com"
                      value={formData.email}
                      onChange={handleInputChange}
                      disabled={submissionStatus.loading}
                    />
                    {formData.email && !errors.email && (
                      <span className="demo-form__icon">
                        <img src="/images/success-mark.svg" alt="success mark" />
                      </span>
                    )}
                  </div>
                  {errors.email && (
                    <span className="demo-form__error">
                      <img src="/images/vulnerability-filled-icon.svg" alt="vulnerability" />
                      <span>{errors.email}</span>
                    </span>
                  )}
                </div>

                {/* Phone Block */}
                <div className="demo-form__row">
                  <label htmlFor="phone" className="demo-form__label">
                    Phone Number
                  </label>
                  <div className="demo-form__phone-wrapper">
                    <div className="demo-form__select-wrapper" ref={dropdownRef}>
                      <img className="demo-form__select-arrow" src="/images/arrow-down.svg" alt="arrow-down" />

                      <div
                        className={`demo-form__select ${isDropdownOpen ? "open" : ""}`}
                        onClick={() => !submissionStatus.loading && setIsDropdownOpen(!isDropdownOpen)}
                        tabIndex={0}
                        onFocus={() => !submissionStatus.loading && setIsDropdownOpen(true)}
                        style={{
                          cursor: submissionStatus.loading ? "not-allowed" : "pointer",
                          opacity: submissionStatus.loading ? 0.6 : 1,
                          position: "relative",
                          padding: "12px 40px 12px 12px",
                          minHeight: "48px",
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: "white",
                        }}
                      >
                        <span style={{ display: "block", textAlign: "left" }}>
                          {getSelectedCountry()?.code || formData.countryCode}
                        </span>

                        {isDropdownOpen && !submissionStatus.loading && (
                          <div
                            ref={dropdownListRef}
                            style={{
                              position: "absolute",
                              fontSize: "16px",
                              top: 60,
                              left: 0,
                              right: 0,
                              borderRadius: "20px",
                              padding: "10px",
                              width: "300px",
                              backgroundColor: "white",
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                            }}
                          >
                            {countries.map((country, index) => (
                              <div
                                key={country.code}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCountrySelect(country.code);
                                }}
                                onMouseEnter={() => setHighlightedIndex(index)}
                                style={{
                                  padding: "12px",
                                  cursor: "pointer",
                                  borderRadius: "10px",
                                  backgroundColor: highlightedIndex === index ? "#f0f0f0" : "white",
                                }}
                              >
                                {country.name} ({country.code})
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      {/* Hidden input for form submission */}
                      <input type="hidden" name="countryCode" value={formData.countryCode} />
                    </div>
                    <div className="demo-form__input-wrapper">
                      <input
                        type="tel"
                        id="demo-form-phone-input"
                        name="phone"
                        className={`demo-form__input ${errors.phone ? "error" : formData.phone ? "success" : ""}`}
                        placeholder="569913445"
                        value={formData.phone}
                        onChange={handleInputChange}
                        disabled={submissionStatus.loading}
                      />
                      {formData.phone && !errors.phone && (
                        <span className="demo-form__icon">
                          <img src="/images/success-mark.svg" alt="success mark" />
                        </span>
                      )}
                    </div>
                  </div>
                  {errors.phone && (
                    <span className="demo-form__error">
                      <img src="/images/vulnerability-filled-icon.svg" alt="vulnerability" />
                      <span>{errors.phone}</span>
                    </span>
                  )}
                </div>

                {/* Product Interest Selection */}
                <div className="demo-form__row">
                  <label className="demo-form__label">What are you interested in?</label>
                  <div className="demo-form__products-grid">
                    {products.map((product) => (
                      <div
                        key={product.id}
                        className={`demo-form__product-card ${
                          formData.interestedProducts.includes(product.id) ? "selected" : ""
                        }`}
                        onClick={() => !submissionStatus.loading && handleProductSelection(product.id)}
                        style={{
                          cursor: submissionStatus.loading ? "not-allowed" : "pointer",
                          opacity: submissionStatus.loading ? 0.6 : 1,
                        }}
                      >
                        <div className="demo-form__product-header">
                          <h4 className="demo-form__product-name">{product.name}</h4>
                          <div
                            className={`demo-form__product-checkbox ${
                              formData.interestedProducts.includes(product.id) ? "checked" : ""
                            }`}
                          >
                            {formData.interestedProducts.includes(product.id) && (
                              <img src="/images/success-mark.svg" alt="selected" />
                            )}
                          </div>
                        </div>
                        <p className="demo-form__product-description">{product.description}</p>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Textarea */}
                <div className="demo-form__row">
                  <label htmlFor="message" className="demo-form__label">
                    Message (Optional)
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    className="demo-form__textarea"
                    placeholder="Your message here"
                    value={formData.message}
                    onChange={handleInputChange}
                    disabled={submissionStatus.loading}
                  ></textarea>
                </div>

                {/* Submit Button */}
                <div className="demo-form__row">
                  <button
                    type="submit"
                    className={`demo-form__button btn btn-primary ${submissionStatus.loading ? "loading" : ""}`}
                    disabled={submissionStatus.loading}
                  >
                    {submissionStatus.loading ? "Sending..." : "Request My Free Demo"}
                  </button>
                </div>

                {/* Honeypot field to prevent spam */}
                <div style={{ display: "none" }}>
                  <input type="text" name="botcheck" />
                </div>
              </form>
            </ScrollReveal>

            <ScrollReveal direction="right" delay={400} className="demo-benefits">
              <div className="demo-benefits__image resonance-image glass-border-wrapper">
                <img src="/images/team-success.svg" alt="Demo Benefits" />
              </div>

              <div className="demo-benefits__content">
                <h3 className="demo-benefits__title">Why Try spiderSilk?</h3>
                <h4 className="demo-benefits__subtitle">Here's what to expect from your free demo:</h4>

                <ul className="demo-benefits__list">
                  <li className="demo-benefits__list-item">
                    <div className="demo-benefits__list-item-icon complete-mark"></div>
                    <span>Live walkthrough of the product</span>
                  </li>
                  <li className="demo-benefits__list-item">
                    <div className="demo-benefits__list-item-icon complete-mark"></div>
                    <span>Overview of how we find hidden exposures others miss</span>
                  </li>
                  <li className="demo-benefits__list-item">
                    <div className="demo-benefits__list-item-icon complete-mark"></div>
                    <span>Customized view based on your industry and needs</span>
                  </li>
                  <li className="demo-benefits__list-item">
                    <div className="demo-benefits__list-item-icon complete-mark"></div>
                    <span>Clear pricing and implementation timeline</span>
                  </li>
                  <li className="demo-benefits__list-item">
                    <div className="demo-benefits__list-item-icon complete-mark"></div>
                    <span>All your questions answered by security experts</span>
                  </li>
                </ul>
              </div>
            </ScrollReveal>
          </div>
        </section>
      </main>
    </>
  );
};

export default BookDemoPage;
